import * as types from "./mutation-types"

export default {
  [types.signIn](state: any, obj: any) {
    state.loggedIn = true
    localStorage.setItem("user-token", obj.token)
    localStorage.setItem("user-details", JSON.stringify(obj.details || {}))
    state.token = obj.token
    state.details = obj.details
    let permissions = [] as Object[]
    for (const role of obj.details.roles) {
      for (const permission of role.permissions) {
        permissions.push(permission.slug)
      }
    }
    state.permissions = permissions
    localStorage.setItem("permissions", JSON.stringify(permissions, []))
  },
  [types.logout](state: any) {
    state.loggedIn = false
    localStorage.removeItem("user-token")
    localStorage.removeItem("user-details")
    localStorage.removeItem("permissions")
  },
  [types.save_profile](state: any, { roles, ...details }: any) {
    state.details = details
    let permissions = [] as Object[]
    for (const role of roles) {
      for (const permission of role.permissions) {
        permissions.push(permission.slug)
      }
    }
    localStorage.setItem("permissions", JSON.stringify(permissions))
    state.permissions = permissions
  },
}
